import { Grid, TextField, Button } from "@material-ui/core"
import * as yup from "yup";
import { useFormik } from "formik";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DialogMessage } from "../../../global/DialogMessage";
import { ToastMessage } from "../../../global/ToastMessage";
import { targetPasajeroCheckin, modalPasajeroCheckin, updatePasajeroCheckin, obtenerPasajerosDocumentos, newPasajeroCheckin } from "../../../ducks/clientesDuck";
import { esFinalizado } from "../../../utils/esFinalizado";
import { makeStyles } from "@material-ui/core";
import { onlyCatacterAcentos } from "../../../utils/yupCustomShema";
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import dayjs from 'dayjs'
import PickerMod from "../../../global/PickersMod";
const validationSchema = yup.object({
    nombre: yup
        .string("Ingrese un nombre")
        .required("Nombre es requerido")
        .matches(onlyCatacterAcentos, "Solo se aceptan letras"),
    apellidoPaterno: yup
        .string("Ingrese un apellido paterno")
        .matches(onlyCatacterAcentos, "Solo se aceptan letras")
        .optional(),
    apellidoMaterno: yup
        .string("Ingrese un apellido materno")
        .matches(onlyCatacterAcentos, "Solo se aceptan letras")
        .optional(),
    numPassaporte: yup
        .string("Ingrese un numero de pasaporte")
        .optional(),
    nacionalidad: yup
        .string("Ingrese una nacionalidad")
        .optional()
})
const InitialValues = {
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    numPassaporte: "",
}
const ArrayFormValues = [
    {
        name: "nombre",
        type: "text",
        label: "Nombre"
    },
    {
        name: "apellidoPaterno",
        type: "text",
        label: "Apellido paterno"
    },
    {
        name: "apellidoMaterno",
        type: "text",
        label: "Apellido materno"
    },
    {
        name: "numPassaporte",
        type: "text",
        label: "Pasaporte"
    },
]

export const FCortizadorStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 0",
        padding: "1rem",
        maxHeight: "80vh",
        overflowY: "scroll"
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },
    paper: {
        maxWidth: 700,
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),

    },
    formControl: {
        margin: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
}));

const FielEditPicker = (props) => {
    const {
        id,
        label,
        verificado,
        disablePast,
        disableFuture,
        value,
        setValue
    } = props
    const [editar, setEditar] = useState(false)
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    return (
        <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <PickerMod
                id={id}
                label={label}
                disablePast={disablePast}
                disableFuture={disableFuture}
                disabled={verificado || !editar}
                selectedDate={value}
                setSelectedDate={setValue}
            />
            {
                (!editar) &&
                <Button
                    style={{ margin: "0 2%" }}
                    variant="contained"
                    color="primary"
                    disabled={verificado}
                    onClick={hangdleClickEditar}
                >
                    Editar
                </Button>
            }
            {
                (editar) &&
                <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="primary"
                        disabled={verificado}
                        type="submit"
                    >
                        Guardar
                    </Button>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="default"
                        disabled={verificado}
                        onClick={hangdleClickEditar}
                    >
                        Cancelar
                    </Button>
                </div>
            }
        </div>
    )
}
const FielEdit = (props) => {
    const {
        name,
        label,
        type = "text",
        verificado,
        formik,
    } = props
    const [editar, setEditar] = useState(false)
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    return (
        <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <TextField
                required
                disabled={verificado || !editar}
                style={{ width: "100%" }}
                id={`id-${name}`}
                label={label}
                type={type}
                variant="outlined"
                name={name}
                value={formik.values[name]}
                onChange={formik.handleChange}
                error={formik.touched[name] && Boolean(formik.errors[name])}
                helperText={formik.touched[name] && formik.errors[name]}
            />
            {
                (!editar) &&
                <Button
                    style={{ margin: "0 2%" }}
                    variant="contained"
                    color="primary"
                    disabled={verificado}
                    onClick={hangdleClickEditar}
                >
                    Editar
                </Button>
            }
            {
                (editar) &&
                <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="primary"
                        disabled={verificado}
                        type="submit"
                    >
                        Guardar
                    </Button>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="default"
                        disabled={verificado}
                        onClick={hangdleClickEditar}
                    >
                        Cancelar
                    </Button>
                </div>
            }
        </div>
    )
}
const FCheckIn = () => {
    const { cliente, modalPasajero, targetPasajero } = useSelector(store => store.cliente)
    const [value, setValue] = useState(dayjs())
    const [venPasaporte, setVenPasaporte] = useState(dayjs())
    const dispatch = useDispatch()
    const classes = FCortizadorStyle()
    const formik = useFormik({
        initialValues: InitialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => handleSubmit(values),
    })
    const handleChangeValue = (value) => {
        setValue(value)
    }
    const handleChangeVenPasaporte = (value) => {
        setVenPasaporte(value)
    }
    const handleClose = () => {
        dispatch(modalPasajeroCheckin({ open: false }))
        dispatch(targetPasajeroCheckin({ pasajero: {} }))
        formik.resetForm(InitialValues)
    }
    const handleSubmit = (values) => {
        let payload = {}
        payload.IdPasajero = targetPasajero?.Pasajero?.idPasajero ?? 0
        payload.IdCatTipoPasajero = targetPasajero?.TipoPasajero?.IdCatTipoPasajero
        payload.idCuenta = cliente?.Movimiento?.Cuenta?.Id_Cuenta
        payload.IdPaquete = cliente?.paquete?.Id_Paquete
        payload.Nombre = values.nombre
        payload.ApellidoPaterno = values.apellidoPaterno
        payload.ApellidoMaterno = values.apellidoMaterno
        payload.FechaNacimiento = dayjs(value).format('YYYY-MM-DD')
        payload.Nacionalidad = "No Aplica"
        payload.NumeroPasaporte = values.numPassaporte
        payload.FechaVencimiento = dayjs(venPasaporte).format('YYYY-MM-DD')
        payload.Internacional = cliente?.paquete?.Internacional

        DialogMessage.fire({
            titleText: `¿Está seguro que los datos mostrados son correctos?`,
            html: `Nombre completo: <b>${payload.Nombre} ${payload.ApellidoPaterno} ${payload.ApellidoMaterno}</b>
            </br> Fecha de nacimiento: <b>${payload.FechaNacimiento}</b>
            </br> Número de pasaporte: <b>${payload.NumeroPasaporte}</b>
            </br> Fecha de expiración: <b>${payload.FechaVencimiento}</b>
            </br> <b>La información sera utilizada para la compra de tu viaje </b>`,
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: "#009bdb",
            cancelButtonText: "Cancelar",
            icon: "info"
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                if (targetPasajero?.Pasajero?.idPasajero > 0) {
                    dispatch(updatePasajeroCheckin(payload)).then(Response => {
                        dispatch(offLoadAction())
                        if (Response?.status === 200) {
                            ToastMessage.fire({
                                title: "Operacion exitosa",
                                icon: "success",
                                confirmButtonColor: "#009bdb",
                                confirmButtonText: "Aceptar",
                            })
                            dispatch(obtenerPasajerosDocumentos({ idPaquete: cliente?.paquete?.Id_Paquete }))
                        }
                    })
                } else  {
                    dispatch(newPasajeroCheckin(payload)).then(Response => {
                        dispatch(offLoadAction())
                        if (Response?.status === 200) {
                            ToastMessage.fire({
                                title: "Operacion exitosa",
                                icon: "success",
                                confirmButtonColor: "#009bdb",
                                confirmButtonText: "Aceptar",
                            })
                            dispatch(obtenerPasajerosDocumentos({ idPaquete: cliente?.paquete?.Id_Paquete }))
                        }
                    })
                }
            }
        })
    }

    useEffect(() => {
        if (targetPasajero?.Pasajero?.idPasajero) {
            setValue(dayjs(targetPasajero?.Pasajero?.FechaNacimiento))
            setVenPasaporte(dayjs(targetPasajero?.Pasajero?.documento?.FechaVencimiento))
            formik.setFieldValue("nombre", targetPasajero?.Pasajero?.Nombre)
            formik.setFieldValue("apellidoPaterno", targetPasajero?.Pasajero?.ApellidoPaterno)
            formik.setFieldValue("apellidoMaterno", targetPasajero?.Pasajero?.ApellidoMaterno)
            formik.setFieldValue("numPassaporte", targetPasajero?.Pasajero?.documento?.NumeroPasaporte)
        }
    }, [targetPasajero]) //eslint-disable-line

    return (
        <ModalBase classes={classes} open={modalPasajero} onClose={handleClose}>
            <HeaderModal handleClose={handleClose} titulo={`Finalizar viaje`} />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container>
                            {
                                ArrayFormValues.map((item, index) =>
                                    <Grid item xs={12} key={item.name}>
                                        <FielEdit
                                            name={item.name}
                                            label={item.label}
                                            type={item.type}
                                            verificado={esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                                            formik={formik}
                                        />
                                    </Grid>
                                )
                            }
                            <Grid item xs={12}>
                                <FielEditPicker
                                    id={"PickerFechaNacimiento"}
                                    label={"Fecha de nacimiento"}
                                    disablePast={false}
                                    disableFuture={true}
                                    value={value}
                                    setValue={handleChangeValue}
                                    verificado={esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FielEditPicker
                                  id={"PickerFechaVencimientoPasaporte"}
                                  label={"Fecha de vencimiento pasaporte"}
                                  disablePast={true}
                                  disableFuture={false}
                                  value={venPasaporte}
                                  setValue={handleChangeVenPasaporte}
                                  verificado={esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                                />
                            </Grid>
                        </Grid>

                    </form>
                </Grid>
                <Grid item xs={12}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2rem" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleClose}
                        >
                            Aceptar
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </ModalBase>
    )
}
export default FCheckIn